export default function MarketingSvg({
  fill,
  animated,
  size,
}: {
  fill?: string;
  animated?: boolean;
  size?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 798.39 91.18"
      className={` ${size && size === "lg" ? "w-96 max-w-full" : "w-64 max-h-7 2xl:max-h-8"}`}
      aria-label="TMRW Marketing"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="svg-text"
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M0,34.64V22.85H9.43V13.32l14.74-3.24V22.85H36.06V34.64H24.17V55.86c0,2.16.69,2.75,2.85,2.75h9.63V71H23.58C13.26,71,9.43,67.65,9.43,58V34.64Z"
          />
          <path
            className="svg-text"
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M41.85,71V21.87H55.41l1,6.19h1c3.34-4.23,8-7.67,15.43-7.67,7.86,0,13.07,3.74,16.8,8.75h1c3.83-5,9.63-8.75,18.27-8.75,12.78,0,19.85,8.75,19.85,20.73V71H114V45.35c0-8.16-2.26-12.19-9.62-12.19s-11.7,5.21-11.7,12.48V71H77.91V45.35c0-8.16-2.26-12.19-9.63-12.19S56.59,38.57,56.59,45.84V71Z"
          />
          <path
            className="svg-text"
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M134.89,71V21.87h13.56l1,6.19h1A18.81,18.81,0,0,1,166,20.59c12.77,0,20,8.74,20,20.73v4.13H171.34V43.18c0-6.58-3.25-10-9.83-10-7.37,0-11.89,5.41-11.89,12.68V71Z"
          />
          <path
            className="svg-text"
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M186.44,21.87h15.62L210.41,59h1L222.1,21.87h18.27L251.08,59h1l8.35-37.13H276L262,71H241.55L231.24,36.11,220.92,71H200.49Z"
          />
          <circle
            className={`svg-dot ${animated ? "animated" : ""}`}
            fill="#fc473c"
            cx="283.47"
            cy="61.24"
            r="11.34"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M300.62,71.42V22h13.63l1,6.22h1c3.36-4.25,8-7.7,15.51-7.7,7.9,0,13.14,3.75,16.89,8.79h1c3.85-5,9.68-8.79,18.37-8.79,12.84,0,20,8.79,20,20.84v30H373.13V45.64c0-8.2-2.27-12.25-9.68-12.25s-11.76,5.23-11.76,12.55V71.42H336.87V45.64c0-8.2-2.27-12.25-9.68-12.25s-11.75,5.43-11.75,12.74V71.42Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M392.39,40.9c1-12.94,10.47-20.55,27.46-20.55,17.88,0,27.07,7,27.07,21.14V71.42H433.28l-1-6.22h-1c-4.05,4.74-10.28,7.7-18.38,7.7-11.36,0-19.06-5.53-19.06-14.91,0-9.88,9.18-15.71,23.61-15.71a75.56,75.56,0,0,1,14.62,1.48V41.39c0-6.42-3-9.19-12.25-9.19-8.5,0-12.25,2.87-12.84,8.7Zm24.69,20.15c7.61,0,13.73-3.06,15.41-8.1a83.09,83.09,0,0,0-14-1.19c-6.33,0-9.59,1.58-9.59,4.74S412.14,61.05,417.08,61.05Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M453.13,71.42V22h13.64l1,6.22h1a18.91,18.91,0,0,1,15.71-7.5c12.84,0,20.15,8.79,20.15,20.84v4.15H489.78V43.47c0-6.62-3.26-10.08-9.87-10.08-7.41,0-12,5.43-12,12.74V71.42Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M508.13,71.42V5.24H523V38h1l16.69-16h20.16L536.68,43.76,563,71.42H543.2L523.94,49.89h-1V71.42Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M586.37,20.55c18.17,0,30.33,11.36,28.84,29.53h-43c1.09,6.42,6.52,10.57,14.23,10.57,6.81,0,11.36-2.76,13.33-7.31h15.71c-2.77,11.76-13.83,19.56-29,19.56C569,72.9,557,62.33,557,46.73S569.08,20.55,586.37,20.55ZM599.31,40.6c-1-4.94-5.93-8-12.74-8s-13,3.06-13.93,8Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M615.93,34.87V23h9.48V13.43l14.82-3.26V23h11.95V34.87H640.23V56.21c0,2.17.69,2.76,2.86,2.76h9.68V71.42H639.63c-10.37,0-14.22-3.36-14.22-13V34.87Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M665.42,0c6.32,0,10.86,3.66,10.86,8.4s-4.54,8.39-10.86,8.39-10.87-3.65-10.87-8.39S659.09,0,665.42,0Zm7.4,71.42H658V22h14.81Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M679.34,71.42V22H693l1,6.22h1c3.36-4.34,9.39-7.7,17.19-7.7,13.83,0,22.72,7.7,22.72,23.9v27H720V46.63c0-9.19-2.67-13.44-11.85-13.44-8.5,0-14,4.64-14,13.54V71.42Z"
          />
          <path
            fill={fill && fill === "white" ? "#fff" : "#131414"}
            d="M765.1,20.55c8.2,0,14.32,3.26,17.68,7.5h1l1-6h13.63V66.38c0,15.51-11.07,24.8-29.24,24.8-15.91,0-27.76-8-28.85-19.56h14.82c1,4.74,5.83,7.7,14,7.7,10.07,0,14.42-3.85,14.42-12.94V62.23h-1c-3.36,4.25-9.28,7.51-17.48,7.51-14.33,0-25.59-10.07-25.59-24.6S750.77,20.55,765.1,20.55Zm4.15,37c9.38,0,14.52-5.73,14.52-12.45S778.63,32.7,769.25,32.7s-14.53,5.13-14.53,12.44S759.86,57.59,769.25,57.59Z"
          />
        </g>
      </g>
    </svg>
  );
}
